import _ from 'lodash';

const useGetS3FileName = () => {
  const getS3FileName = (url: string, fallback = 'file') => {
    if (!_.isString(url) || _.isEmpty(url)) {
      return fallback;
    }

    return _.flow([
      (u) => _.split(u, '?')[0],
      (u) => _.split(u, '/'),
      _.last,
      (name) => {
        try {
          return decodeURIComponent(name) || fallback;
        } catch (e) {
          return name || fallback;
        }
      },
    ])(url);
  };
  return getS3FileName;
};

export default useGetS3FileName;
